import { PURPOSES } from '@ratehub/documents/mtg-journey-document/stable';


/**
 * The wizard only supports a few enum values from Purpose.
 * Scenario view models are instantiated based on the "scenario type".
 *
 * In future we'd like to directly use the purpose and derrive state based on the document.
 * And we'd like to get rid of scenario type, and just use purpose and transaction type (the main purpose types) directly.
 *
 * @param {PURPOSES[keyof PURPOSES]} purpose
 * @returns {string} scenarioType
 */
function getScenarioTypeFromPurpose(purpose) {
    switch (purpose) {
        case PURPOSES.PURCHASE_FOUND_PROPERTY:
            return PURPOSES.PURCHASE;

        case PURPOSES.PURCHASE_STILL_LOOKING:
            return PURPOSES.PRE_APPROVAL;

        case PURPOSES.REFINANCE_ACCESS_EQUITY:
        case PURPOSES.REFINANCE_CONSOLIDATE_DEBT:
        case PURPOSES.REFINANCE_LOWER_INTEREST:
        case PURPOSES.REFINANCE_OTHER:
            return PURPOSES.REFINANCE;

        // is not a sub-type (eg. renewal)
        default:
            return purpose;
    }
}

export default getScenarioTypeFromPurpose;
